"use strict";

const SamplingSiteFactSheetController = function () {
  const routeName = "sampling-site-fact-sheet";

  var getConfig = function () {
    return {
      template: "factSheet/samplingSite/samplingSiteFactSheet.njk",
      pointColumnName: "geom",
      iconFunction: SamplingSiteIcon.getSamplingSiteIconClass,
      closeUrl: UrlRoutes.getDefaultUrl(),
      goToMapFunction: () => Analytics.sendDataListEvent("address_to_map"),
      getDataFunction: getData,
      prepareDataFunction: prepareData,
      onCloseFunction: onClose,
      afterOpenFunction: afterOpen,
      readOnlyPhotos: true,
      apiAssetName: "samplingSite",
    };
  };

  var getData = async function (id) {
    return await ApiCalls.getSamplingSiteForFactSheet(id);
  };

  var prepareData = function (data) {
    data.dataView = Tree.get("dataView");
    data.phaseColor = SamplingSiteIcon.getConditionColor(null, true);
    data.phaseTextColor = Misc.isDarkColor(data.phaseColor) ? "#fff" : "#000";
  };

  var open = async function (id, options = {}) {
    FactSheetNew.open(id, getConfig(), null, options);
  };

  var afterOpen = function () {
    _loadListeners();
  };

  var _unloadListeners = function () {};

  var _loadListeners = function () {
    _unloadListeners();
  };

  var onClose = function () {
    _unloadListeners();
  };

  return {
    routeName,
    open,
    getConfig,
  };
};

module.exports = SamplingSiteFactSheetController();

const ApiCalls = require("../apiCalls");
const FactSheetNew = require("../general/factSheetNew");
const Analytics = require("../general/analytics");
const Tree = require("../tree");
const Misc = require("../misc");
const SamplingSiteIcon = require("./samplingSiteIcon");
const UrlRoutes = require("../routes/urlRoutes");
